import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { BarI18nPipe } from '../../i18n/bar-i18n.pipe';
import { BaasOffcanvasOptions } from './baas-offcanvas-options';
import { BaasOffcanvasWidth } from './baas-offcanvas-width';

@Component({
    selector: 'baas-offcanvas',
    templateUrl: './baas-offcanvas.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, MatIconButton, MatTooltip, BarI18nPipe],
    host: {
        class: 'lv-offcanvas',
        '[class.lv-offcanvas--opened]': 'isOpened()',
        '[class.lv-offcanvas--closed]': '!isOpened()',
        '[class.lv-offcanvas--pinned]': 'isPinned() && isOpened()',
        '[class.lv-offcanvas--unpinned]': '!isPinned() && isOpened()',
        '[class.lv-offcanvas--half-width]': 'width() === "half"'
    }
})
export class BaasOffcanvas {
    readonly isOpened = model<boolean>(false);
    readonly isPinned = model<boolean>(false);
    readonly width = input<BaasOffcanvasWidth>('default');
    readonly options = input<BaasOffcanvasOptions | undefined>(undefined);
    // eslint-disable-next-line @angular-eslint/no-output-native
    readonly close = output<void>();

    protected readonly pinLabelKey = computed(() => `DOMAIN_BAR_LAYOUT.OFFCANVAS.${this.isPinned() ? 'UNPIN' : 'PIN'}`);

    protected onClose(): void {
        this.close.emit();
    }

    protected onTogglePin(): void {
        this.isPinned.update((pinned) => !pinned);
    }
}
